document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".maple_section_custom .block_text");

  function applyBehavior() {
    const isDesktop = window.matchMedia("(min-width: 768px)").matches;

    blocks.forEach((block) => {
      const title = block.querySelector("h4");
      const description = block.querySelector("p");

      // Réinitialiser les styles
      description.style.transition = "max-height 0.5s ease-out, opacity 0.5s";
      description.style.overflow = "hidden";
      description.style.opacity = 0;
      description.style.maxHeight = "0px";

      // Supprimer tous les anciens écouteurs en clonant l'élément
      const newTitle = title.cloneNode(true);
      title.parentNode.replaceChild(newTitle, title);

      if (isDesktop) {
        // Sur desktop (≥ 768px) : opacité au survol
        description.style.maxHeight = ""; // Reset max-height pour éviter les conflits

        newTitle.addEventListener("mouseenter", function () {
          description.style.opacity = 1;
        });

        newTitle.addEventListener("mouseleave", function () {
          description.style.opacity = 0;
        });
      } else {
        // Sur mobile (≤ 767px) : effet "expand" au clic
        newTitle.addEventListener("click", function () {
          if (description.style.maxHeight === "0px") {
            description.style.maxHeight = description.scrollHeight + "px";
            description.style.opacity = 1;
          } else {
            description.style.maxHeight = "0px";
            description.style.opacity = 0;
          }
        });
      }
    });
  }

  applyBehavior(); // Appliquer le comportement au chargement
  window.addEventListener("resize", applyBehavior); // Re-appliquer si la taille change

  // Remove Case format dropdown on Product Recommandations slider
  const product_template = document.querySelector("product-variant-provider");
  if (product_template) {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === "childList") {
          const addedNodes = Array.from(mutation.addedNodes);

          // Trouver TOUS les éléments avec la classe `product-card`
          const foundElements = addedNodes.filter(
            (node) => node.classList && node.classList.contains("#product-card")
          );

          if (foundElements.length > 0) {
            foundElements.forEach((element) => {
              const selectElement = element.querySelector(
                'select[name="Case format"]'
              );
              if (selectElement) {
                selectElement.parentElement.style.display = "none";
              }
            });
            observer.disconnect();
          }
        }
      });
    });

    // Observer les changements dans tout le document
    observer.observe(document.body, { childList: true, subtree: true });
  }
});
